var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BuyBase",
    {
      staticClass: "tap-pro",
      attrs: {
        title: _vm.getConstants("PRICING_NEW_COMMON_PRO"),
        actions: _vm.getConstants("PRICING_NEW_TAP_CHECK_DETAIL"),
        type: "pro"
      },
      on: { viewDetail: _vm.viewDetail }
    },
    [
      _c(
        "div",
        { attrs: { slot: "limit" }, slot: "limit" },
        [
          _c("div", { staticClass: "banner" }, [
            _c("img", { attrs: { src: _vm.bannerSrc, alt: "" } })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "tp-op-price" }, [
            _c("p", { staticClass: "save" }, [
              _c("img", {
                attrs: { src: require("../../images/sales.png"), alt: "" }
              }),
              _vm._v(
                "\n\t\t\t\t" +
                  _vm._s(_vm.getConstants("PRICING_NEW_PAY_PRO_MAIN")) +
                  "\n\t\t\t"
              )
            ])
          ]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.space))]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.add))]),
          _vm._v(" "),
          _c("UploadTip"),
          _vm._v(" "),
          _vm.upgradeVisible
            ? _c("UpgradeTip", {
                staticClass: "upgrade-tip-pro",
                on: {
                  close: function($event) {
                    _vm.upgradeShowed = true
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }